// Angular
import { Injectable } from '@angular/core';
// RxJS
import { BehaviorSubject } from 'rxjs';
// Object path
import * as objectPath from 'object-path';
// Services
import { MenuConfigService } from './menu-config.service';
import { COEApiService } from 'src/app/Services/coe.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class MenuHorizontalService {
	// Public properties
	menuList$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
	entityMenuList$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
	studentMenuList$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

	/**
	 * Service constructor
	 *
	 * @param menuConfigService: MenuConfigService
	 */
	userType = localStorage.getItem('userType')
	entityId = localStorage.getItem('entityId');
	session = localStorage.getItem('session');
	permissions = []
	permissionList = localStorage.getItem('permissions');
	entityPreferences = JSON.parse(localStorage.getItem('entityPreferences'));
	theoryMaskingSetup = localStorage.getItem('theoryMaskingSetup') || (this.entityPreferences && this.entityPreferences.theoryMaskingSetup) || 'masking';
	displayNames: any = { };

	constructor(private menuConfigService: MenuConfigService, private coeService: COEApiService) {
		this.loadMenu();
		this.loadTheoryMaskingSetup();
	}

	/**
	 * Load menu list
	 */
	loadMenu() {
		this.entityPreferences = JSON.parse(localStorage.getItem('entityPreferences'));
		this.theoryMaskingSetup = localStorage.getItem('theoryMaskingSetup') || (this.entityPreferences && this.entityPreferences.theoryMaskingSetup) || 'masking';

		if(this.permissionList){
			this.permissions = this.permissionList.split(',')
			if(this.entityPreferences && this.entityPreferences.displayNames && this.entityPreferences.displayNames.length>0){
				this.displayNames = {
					event : this.entityPreferences.displayNames.filter(item => item.value == 'event')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'event')[0].name : 'Events',
					partnerInstitute : this.entityPreferences.displayNames.filter(item => item.value == 'partnerInstitute')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'partnerInstitute')[0].name : 'Partner Institute',
					sharePoint : this.entityPreferences.displayNames.filter(item => item.value == 'sharePoint')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'sharePoint')[0].name : 'Share Point',
					schoolDiary : this.entityPreferences.displayNames.filter(item => item.value == 'schoolDiary')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'schoolDiary')[0].name : 'School Diary',
					course : this.entityPreferences.displayNames.filter(item => item.value == 'course')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'course')[0].name : 'Class',
					greenSheet : this.entityPreferences.displayNames.filter(item => item.value == 'greenSheet')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'greenSheet')[0].name : 'Green Sheet',
					issuedBooks:this.entityPreferences.displayNames.filter(item => item.value == 'issuedBooks')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'issuedBooks')[0].name : 'Issued Books',
					seminar:this.entityPreferences.displayNames.filter(item => item.value == 'seminar')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'seminar')[0].name : 'Seminar',
					classTest:this.entityPreferences.displayNames.filter(item => item.value == 'classTest')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'classTest')[0].name : 'Class Test',
					rollNo:this.entityPreferences.displayNames.filter(item => item.value == 'rollNo')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'rollNo')[0].name : 'Roll No',
					regNo:this.entityPreferences.displayNames.filter(item => item.value == 'regNo')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'regNo')[0].name : 'Reg No',
					lesson:this.entityPreferences.displayNames.filter(item => item.value == 'lesson')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'lesson')[0].name : 'Lesson',
					studentQuery:this.entityPreferences.displayNames.filter(item => item.value == 'studentQuery')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'studentQuery')[0].name : 'Student Queries',
					advanced: this.entityPreferences.displayNames.filter(item => item.value == 'advanced')[0]?this.entityPreferences.displayNames.filter(item => item.value == 'advanced')[0].name : 'Advanced',
					};
			} else {
				this.displayNames = {
					...this.displayNames,
					advanced: 'Advanced'
				};
			}
		}
		// get menu list

		const menuItems: any[] = objectPath.get(this.menuConfigService.getMenus(), 'adminHeader.items');
		const entityMenuItems: any[] = objectPath.get(this.menuConfigService.getMenus(), 'entityHeader.items');
		const studentMenuItems: any[] = objectPath.get(this.menuConfigService.getMenus(), 'studentHeader.items');

		this.updateMenuTitles(menuItems,'admin','admPermission');
		this.updateMenuTitles(entityMenuItems,'entity','entPermission');
		this.updateMenuTitles(studentMenuItems,'student','studentPermission');
		// this.menuList$.next(adminMenuArray)
		// this.entityMenuList$.next(entityMenuArray)
		 }

	loadTheoryMaskingSetup() {
		if (!this.entityId || !this.session || !this.permissions.includes('coeModule')) return;

		this.coeService.viewCOEMaster(this.entityId, this.session).subscribe(
			(res: any) => {
				const theoryMaskingSetup = res && res.theoryMaskingSetup ? res.theoryMaskingSetup : 'masking';
				localStorage.setItem('theoryMaskingSetup', theoryMaskingSetup);
				if (this.theoryMaskingSetup !== theoryMaskingSetup) {
					this.theoryMaskingSetup = theoryMaskingSetup;
					this.loadMenu();
				}
			},
			() => {}
		);
	}

	updateMenuTitles(entityMenuItems: any[],menuType:string,permissionType:string): void {
		if (!Array.isArray(entityMenuItems)) return;

		const transformMenuItems = (menuItems: any[]): any[] => {
			let updatedMenuItems = [];

			for (let item of menuItems) {
				// Check if the user has permission for the current menu item
				let flag ;
				if(item.title == 'Employee Announcement')
				{
					flag = this.permissions.includes('viewEmployeeAnnouncementList') || this.permissions.includes('viewEmployeeCircularList') || this.permissions.includes('viewEmployeeNoticeList')
				}else{
					flag =this.permissions.includes(item[permissionType])
				}
				if (flag) {
					if (item.title === 'Theory Marks Entry') {
						item.page = this.theoryMaskingSetup === 'noMasking' ? '/coe/theoryMarksEntryRegNoWise' : '/coe/marksEntry';
					}

					// if (item.title === 'LMS') {
					// 	if (this.userType === 'od2') {
					// 		item.page = 'https://qa.extramarksforte.com/faculty-admin-dashboard';
					// 	} else if (this.userType === 'od3') {
					// 		item.page = 'https://qa.extramarksforte.com/faculty-assessment-dashboard';
					// 	}
					// }

					if (item.title === 'CMS' || item.page === '/cms') {
						let browserDomain = window.location.hostname;
						if (!browserDomain.includes('extramarks')) {
							let hostName = window.location.hostname;
							let domainParts = hostName.split('.');
							let extractedDomain = domainParts.length > 2 ? domainParts.slice(1).join('.') : hostName;
							if (hostName.includes('localhost') || hostName.includes('od-erp-qa') || hostName.includes('web.app') || !hostName.includes('.')) {
								extractedDomain = 'oderp.in';
							}
							if (extractedDomain === 'oderp.in' || extractedDomain === 'odpay.in') {
								let reactConfig = (environment as any).reactConfig || {};
								let config = reactConfig.cms || {};
								let path = config.path || '';
								let redirectUrl = (config.host || '') + extractedDomain + path;
								const entity = localStorage.getItem('entityId') || '';
								const session = localStorage.getItem('session') || '';
								redirectUrl += `${path.includes('?') ? '&' : '?'}entity=${entity}&session=${session}`;
								item.page = redirectUrl;
							}
						}
					}
					// Update the title based on display names
					if (this.entityPreferences && this.entityPreferences.displayNames.length > 0) {
						switch (item.title) {
							case 'Events':
								item.title = this.displayNames.event;
								break;
							case 'Partner Institutes':
								item.title = this.displayNames.partnerInstitute;
								break;
							case 'Share Point':
								item.title = this.displayNames.sharePoint;
								break;
							case 'Attendance Summary':
								item.title = `${this.displayNames.course} Wise Summary`;
								break;
							case 'Course Wise Attendance Report - All Subject':
								item.title = `${this.displayNames.course} Wise Summary- All Subject`;
								break;
							case 'Issue Book Course Wise':
								item.title = `Issue Book ${this.displayNames.course} Wise`;
								break;
							case 'Green Sheet':
								item.title = this.displayNames.greenSheet;
								break;
							case 'School Diary':
								item.title = this.displayNames.schoolDiary;
								break;
							case 'Course Wise Schedule':
								item.title = `${this.displayNames.course} Wise Schedule`;
								break;
							case 'Due Fee Report Course Wise':
								item.title = `Due Fee Report ${this.displayNames.course} Wise`;
								break;
							case 'Assign Roll No.':
								item.title = `Assign ${this.displayNames.rollNo}`;
								break;
							case 'Update RegNo':
								item.title = `Update ${this.displayNames.regNo}`;
								break;
							case 'Issued Books':
								item.title = this.displayNames.issuedBooks;
								break;
							case 'Library Issued Books Report':
								item.title =`Library ${this.displayNames.issuedBooks} Report`;
								break;
							case 'Seminar':
								item.title = this.displayNames.seminar;
								break;
							case 'Course Wise Tag Report':
								item.title = `${this.displayNames.course} Wise Tag Report`;
								break;
							case 'Class Test':
								item.title = this.displayNames.classTest;
								break;
							case 'Class Test Green Sheet':
								item.title = `${this.displayNames.classTest} Green Sheet`;
								break;
								case 'Fee Summary - Course Wise':
									item.title = `Fee Summary - ${this.displayNames.course} Wise`;
									break;
								case 'Lesson Management':
										item.title = `${this.displayNames.lesson} Management`;
									break;
								case 'Lesson Plan':
										item.title = `${this.displayNames.lesson}`;
									break;
									case 'Course Wise Insights':
											item.title = `${this.displayNames.course} Wise Insights`;
											break;
									case 'Student Queries':
										item.title = this.displayNames.studentQuery;
										break;
									case 'Student List Course Wise':
										item.title = `Student List ${this.displayNames.course} Wise`;
								        break;
									case 'Course Wise Faculty Average Report':
										item.title = ` ${this.displayNames.course} Wise Faculty Average Report`;
								        break;	
									case 'Advanced':
										item.title = this.displayNames.advanced || 'Advanced';
										break;
							default:
								break;
						}
					}

					if (item.entPermission === 'advancedModule') {
						item.title = this.displayNames.advanced || 'Advanced';
					}

					// Recursively process the submenu if it exists
					if (item.submenu && Array.isArray(item.submenu)) {
						item.submenu = transformMenuItems(item.submenu);
					}

					// Add the item to the updated list if it has permissions
					if(item.title == 'Attendance' && this.entityPreferences && this.entityPreferences.studentAttendanceVersion == 'new')
						{
							updatedMenuItems.push(item);
						}else if(item.title === 'Attendance Old' && this.entityPreferences &&this.entityPreferences.studentAttendanceVersion == 'old')
						{
							updatedMenuItems.push(item)
						}
						else if(item.title === 'Attendance V3' &&  this.entityPreferences && this.entityPreferences.studentAttendanceVersion == 'version3'){
							updatedMenuItems.push(item)
						}
						else{
							if(item.title != 'Attendance' && item.title != 'Attendance Old'  && item.title!='Attendance New' && item.title!='Attendance V3')
							updatedMenuItems.push(item)
						}
				}
			}

			return updatedMenuItems;
		};

		// Start the transformation
		const updatedMenu = transformMenuItems(entityMenuItems);

		// Update the observable or state
		if (menuType === 'admin') {
			this.menuList$.next(updatedMenu);
		} else if (menuType === 'entity') {
			this.entityMenuList$.next(updatedMenu);
		} else if (menuType === 'student') {
			this.studentMenuList$.next(updatedMenu);
		}
	}
}
